import React from 'react';
import { Reveal } from './Reveal';
export function FinalSections() {
  return <>
      <section className="relative overflow-hidden px-5 py-24 sm:px-8 sm:py-32" aria-label="Llamado final" data-id="element-65">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.13),transparent_48%)]" aria-hidden="true" data-id="element-66" />
        <Reveal className="relative mx-auto max-w-3xl text-center" data-id="element-67">
          <h2 className="font-display text-5xl font-bold leading-[0.95] tracking-[-0.05em] text-ivory sm:text-6xl lg:text-7xl" data-id="element-68">
            El próximo cliente no debería depender
            <br data-id="element-69" />
            <em className="font-normal text-gold" data-id="element-70">
              de que alguien te recomiende.
            </em>
          </h2>
          <p className="mx-auto mt-7 max-w-[500px] text-lg leading-8 text-sage" data-id="element-71">
            Tenés el conocimiento para entrenar bien. Ahora ordená cómo
            conseguís y seguís a tus próximos clientes.
          </p>
          <a href="https://librofy-store.myshopify.com/cart/47910701957341:1" className="gold-button mx-auto mt-9 flex min-h-14 w-full max-w-[420px] items-center justify-center bg-gold px-6 font-mono text-[11px] font-bold uppercase tracking-wider text-ink transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold" data-id="element-72">
            Quiero el Megapack — $27.990
          </a>
          <p className="mt-3 text-xs text-sage" data-id="element-73">
            Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </Reveal>
      </section>

      <footer className="border-t border-[#d4af37]/18 px-5 py-8 text-center text-xs text-sage sm:px-8" data-id="element-74">
        <p data-id="element-75">© 2025 Megapack Entrenadores · Todos los derechos reservados</p>
        <nav className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2" aria-label="Enlaces legales" data-id="element-76">
          <a href="#inicio" className="hover:text-gold" data-id="element-77">
            Términos y condiciones
          </a>
          <a href="#inicio" className="hover:text-gold" data-id="element-78">
            Política de privacidad
          </a>
          <a href="#inicio" className="hover:text-gold" data-id="element-79">
            Contacto
          </a>
        </nav>
      </footer>
    </>;
}